export const PERMISSIONS: { [key in string]: string } = {
  requestsList: "PickupRequests.PickupRequestList",
  addRequest: "PickupRequestList.AddPickupRequest",
  viewRequest: "PickupRequests.PickupRequestDetails",
  requestDocuments: "PickupRequestDetails.ManagePickupRequestDocuments",
  requestHistory: "PickupRequestDetails.ViewPickupRequestHistory",
  requestEdit: "PickupRequestDetails.EditPickupRequest",
  requestInvalidate: "PickupRequestDetails.InvalidatePickupRequest",
  requestSend: "PickupRequestDetails.SendPickupRequestToCarrier",
  requestResend: "PickupRequestDetails.ResendPickupRequestToCarrier",
  transactionDetails: "Transactions.TransactionDetailsPage",
};

export const REQUESTS_QUERY_KEY = "pickupRequests";
export const REQUEST_DETAILS_QUERY_KEY = "pickupRequestDetails";
export const REQUEST_DOCUMENTS_QUERY_KEY = "pickupRequestDocuments";
export const REQUEST_ACTIVITIES_QUERY_KEY = "requestsActivities";

export const PAGE_SIZE = 20;

export default PERMISSIONS;
